import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class SiteService extends Service {
	constructor(injector: Injector) {
		super("Site", injector);
	}
}